import React from "react";
import PdfPage from "../components/PdfPage";
import "./index.css";

const DisputeAndArbitation = () => {
  return (
    <main>
      <PdfPage
        h2={"Dispute Resolution/Arbitration"}
        img={"/img/dispute-and-arbitation.jpg"}
        pdf1={"/img/DISPUTES AND ARBITRATION REGULATIONS PSX.pdf"}
        pdf1Text={"Download  In English"}
        pdf2={"/img/DISPUTES-AND-ARBITRATION-REGULATIONS-PSX-URDU.pdf"}
        pdf2Text={"Download In Urdu"}
      />
    </main>
  );
};

export default DisputeAndArbitation;
